import { observer } from 'mobx-react-lite'
import { type CSSProperties } from 'react'
import { Alert } from 'shared/ui'
import { useKnowledgeBaseViewContext } from 'pages/settings/pages/knowledgeBase/context/knowledgeBaseViewContext'

interface IKnowledgeBaseUrlAlertProps {
  margin?: CSSProperties['margin']
}

export const KnowledgeBaseUrlAlert = observer(({ margin }: IKnowledgeBaseUrlAlertProps) => {
  const {
    documentsStore: { urlStore },
  } = useKnowledgeBaseViewContext()
  const { errorMessages, setErrorMessage } = urlStore

  return (
    <>
      {errorMessages.importUrl && (
        <div style={{ margin }}>
          <Alert
            item={{
              type: 'error',
              desc: errorMessages.importUrl,
            }}
            onClose={() => setErrorMessage('importUrl', '')}
          />
        </div>
      )}
    </>
  )
})
